import React from "react"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"

import {
  PromoLandingSection,
  PromoLandingCard,
  PromoLandingMedia,
  PromoLandingImage,
  PromoLandingContent,
  PromoLandingTitle,
  PromoLandingSubtitle,
  PromoLandingCta,
  PromoLandingLinks,
  QuickActionList,
  QuickActionItem,
  QuickActionLink,
  QuickActionText,
  QuickActionLabel,
  QuickActionSublabel,
  QuickActionChevron,
  FaqLine,
  FaqPrompt,
  FaqLink,
  LearnMoreLine
} from "./styled"
import { CrossCompanyPhoneCheck } from "./auth/CrossCompanyPhoneCheck"
import { PROMO_LANDING_DESKTOP_IMAGE, PROMO_LANDING_MOBILE_IMAGE } from "../utils/promoLandingImages"
import { ROUTE_PATHS } from "../utils/routes"

export const GetStartedComponent = (props) => {
  const initialValues = {
    phoneNumber: ""
  }

  return (
    <PromoLandingSection aria-labelledby="promo-landing-heading">
      <PromoLandingCard>
        <PromoLandingMedia>
          <picture>
            <source media="(min-width: 768px)" srcSet={PROMO_LANDING_DESKTOP_IMAGE} />
            <PromoLandingImage
              src={PROMO_LANDING_MOBILE_IMAGE}
              alt=""
              loading="eager"
              decoding="async"
            />
          </picture>
        </PromoLandingMedia>
        <PromoLandingContent>
          <PromoLandingTitle id="promo-landing-heading">
            Money back made simple
          </PromoLandingTitle>
          <PromoLandingSubtitle>
            Log in to see what you qualify for.
          </PromoLandingSubtitle>
          {props.sprintRedirectActive ? (
            <div>
              <CrossCompanyPhoneCheck initialValues={initialValues} />
            </div>
          ) : (
            <PromoLandingCta
              className="btn"
              id="btnSubmit"
              href={process.env.REACT_APP_TMO_ID_AUTH_URL}
              onClick={() => sessionStorage.setItem("isFromStandardPage", true)}
              primary
            >
              Get started
            </PromoLandingCta>
          )}
          <PromoLandingLinks>
            <QuickActionList>
              <QuickActionItem>
                <QuickActionLink href={process.env.REACT_APP_TMO_ID_AUTH_URL_STATUS} rel="noreferrer">
                  <QuickActionText>
                    <QuickActionLabel>Already submitted a rebate?</QuickActionLabel>
                    <QuickActionSublabel>Check rebate status</QuickActionSublabel>
                  </QuickActionText>
                  <QuickActionChevron icon={faChevronRight} aria-hidden="true" />
                </QuickActionLink>
              </QuickActionItem>
              <QuickActionItem>
                <QuickActionLink
                  href={process.env.REACT_APP_TMO_ID_AUTH_URL_DIGITAL}
                  onClick={() => sessionStorage.setItem("isFromStandardPage", true)}
                  rel="noreferrer"
                >
                  <QuickActionText>
                    <QuickActionLabel>Looking for other rebates?</QuickActionLabel>
                    <QuickActionSublabel>Apply for Home Internet rebates and redeem promo codes.</QuickActionSublabel>
                  </QuickActionText>
                  <QuickActionChevron icon={faChevronRight} aria-hidden="true" />
                </QuickActionLink>
              </QuickActionItem>
            </QuickActionList>
            <FaqLine>
              <FaqPrompt>Questions?</FaqPrompt>{" "}
              <FaqLink to={ROUTE_PATHS.FAQ}>
                See rebate FAQ
              </FaqLink>
            </FaqLine>
            <LearnMoreLine>
              Learn about{" "}
              <a href="https://www.t-mobile.com/support/new-to-tmobile/family-freedom" rel="noreferrer">
                Family Freedom
              </a>{" "}
              and{" "}
              <a href="https://www.t-mobile.com/support/new-to-tmobile/keep-and-switch" rel="noreferrer">
                Keep and Switch
              </a>
            </LearnMoreLine>
          </PromoLandingLinks>
        </PromoLandingContent>
      </PromoLandingCard>
    </PromoLandingSection>
  )
}
